import React, { useRef, useState } from "react";
import { FormGroup, Label } from "reactstrap";
import { useDropzone } from "react-dropzone";
import profile_img from "../../assets/images/form_img_upload.png"; // Ensure correct path

const InputFile = ({
  label,
  keyField,
  formik,
//   accept = { "image/*": [] }, // Default: Images, can be overridden
  accept ,
  multiple,
  required = false,
  file,
  setFile,
  ...props
}) => {
  const [fileSelected, setFileSelected] = useState(file || null);

  // Handle file selection via Dropzone
  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      setFileSelected(file);
      setFile(file);
      formik.setFieldValue(keyField, file);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    // accept,
    accept: accept || { "image/*": [] },
    multiple: multiple
  });

  return (
    <div className="organization_content">
      <FormGroup>
        <Label htmlFor={keyField}>
          {label} {required && <span style={{ color: "red" }}>*</span>}
        </Label>
        <div {...getRootProps()} className="upload-area text-center">
          <input {...getInputProps()} />
          <img src={profile_img} alt="upload" />
          <p>Drag & drop files here, or click to browse</p>
          <button type="button" className="browse_blk">Browse</button>
        </div>

        {/* Show uploaded file name */}
        {fileSelected && (
          <div className="uploaded-files mt-3">
            <div className="file-item d-flex justify-content-between align-items-center">
              <p>{fileSelected.name}</p>
              <button
                type="button"
                className="cancel-btn"
                onClick={() => {
                  setFileSelected(null);
                  setFile(null);
                  formik.setFieldValue(keyField, null);
                }}
              >
                <i className="fas fa-times" />
              </button>
            </div>
          </div>
        )}
      </FormGroup>
    </div>
  );
};

export default InputFile;

